__turbopack_context__.v({
  "accordion": "uF9gGa_accordion",
  "accordion__content": "uF9gGa_accordion__content",
  "accordion__icon": "uF9gGa_accordion__icon",
  "accordion__section": "uF9gGa_accordion__section",
  "accordion__text": "uF9gGa_accordion__text",
  "accordion__title": "uF9gGa_accordion__title",
  "active": "uF9gGa_active",
  "rotate": "uF9gGa_rotate",
});
